import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Heading, PageContainer, Text } from './ui';
import '../styles/NotFound.css';

// Generic 404 page. Cream Card on the olive page surface, Direction A
// typography, primary Button back to the home route.
function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="not-found-page">
      <PageContainer maxWidth="readable" className="not-found-inner">
        <Card
          as="section"
          variant="default"
          padding="xl"
          className="not-found-card"
        >
          <span className="not-found-eyebrow">404</span>
          <Heading level={1} className="not-found-title">
            Page not found
          </Heading>
          <Text size="md" variant="muted" className="not-found-body">
            The page you&rsquo;re looking for doesn&rsquo;t exist or has been
            moved.
          </Text>
          <Button
            type="button"
            variant="primary"
            onClick={() => navigate('/')}
            className="not-found-cta"
          >
            Return to home
          </Button>
        </Card>
      </PageContainer>
    </div>
  );
}

export default NotFound;
